import React from "react";
import "../MonopolyPrivacyPolicy/style.css";
import ContactSpin from "../SpinMasterPrivacyPolicy/ContactSpin";

const MonopolyTermsAndConditions = () => {
  return (
    <div className="monopoly-policy-main" style={{ backgroundColor: "transparent" }}>
      <h1>Terms and Conditions For Dice Links for Monopoly GO</h1>
      <p>Last Updated: 29 May, 2026</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing and using Dice Links for Monopoly GO (the "Application"), you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not use the Application.
      </p>

      <h2>2. Service Description</h2>
      <p>
        Dice Links for Monopoly GO is a utility application designed to provide users with aggregated links, rewards, and tips related to the Monopoly Go game. We do not own, develop, or manage the official Monopoly Go game.
      </p>

      <h2>3. Disclaimer of Affiliation</h2>
      <p>
        Our Application is an independent, unofficial tool. We are <strong>NOT</strong> affiliated with, endorsed by, sponsored by, or officially connected to Scopely, Hasbro, or the official Monopoly Go game developers in any way. All trademarks and copyrights belong to their respective owners.
      </p>

      <h2>4. Virtual Items and Rewards</h2>
      <p>
        The rewards and links provided in the Application are sourced from publicly available channels. We do not guarantee the availability, validity, or functionality of any specific link or reward, as they are controlled by the official game developers and may expire at any time.
      </p>
      <p>
        <strong>Apple Disclaimer:</strong> Apple Inc. is NOT a sponsor of, nor is it involved in any way with, the rewards, virtual items, or promotions provided within this Application.
      </p>

      <h2>5. User Conduct</h2>
      <p>While using our Application, you agree not to:</p>
      <ul>
        <li>Use the Application for any illegal or unauthorized purpose.</li>
        <li>Attempt to hack, reverse engineer, or disrupt the Application's services.</li>
        <li>Use automated scripts, bots, or emulators to exploit the Application.</li>
      </ul>

      <h2>6. Advertising and Third-Party Links</h2>
      <p>
        The Application displays advertisements provided by third-party networks (such as Google AdMob). We are not responsible for the content of these ads or the websites they link to. Your interactions with advertisers are solely between you and the third party.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        The Application is provided on an "AS IS" and "AS AVAILABLE" basis. To the maximum extent permitted by law, we disclaim all warranties and shall not be liable for any indirect, incidental, or consequential damages resulting from your use of the Application, including but not limited to the expiration of rewards or links.
      </p>

      <h2>8. Termination</h2>
      <p>
        We reserve the right to modify, suspend, or terminate the Application or your access to it at any time, without prior notice, for any reason whatsoever.
      </p>

      <h2>9. Indemnification</h2>
      <p>
        You agree to defend, indemnify, and hold us harmless from and against any claims, liabilities, damages, losses, and expenses arising out of or in any way connected with your use of the Application or violation of these Terms.
      </p>

      <h2>10. Changes to Terms</h2>
      <p>
        We may update these Terms and Conditions from time to time. By continuing to use the Application after revisions become effective, you agree to be bound by the updated terms.
      </p>

      <h2>11. Contact Us</h2>
      <p>If you have any questions about these Terms and Conditions, please contact us:</p>
      <ContactSpin isMonopoly={true} />
    </div>
  );
};

export default MonopolyTermsAndConditions;
